import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { marketplacesLBBReportFormIsOpen, marketplacesLBBSubmittedFilters } from "../../@signals"


export default function useMarketplacesLBBReportForm() {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal("")
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])
    const includeOnlyNewProducts = useSignal('No')

    const resetFormData = () => {
        nameReport.value = ""
        frequency.value = null
        emailsReport.value = [userEmail]
    }

    const handleOpenForm = () => {
        marketplacesLBBSubmittedFilters.value = { ...marketplacesLBBSubmittedFilters.value }
        marketplacesLBBReportFormIsOpen.value = true
    }

    const normalizedConditionsFilters = () => {
        return {
            includeOnlyNewProducts: includeOnlyNewProducts.value === 'Yes',
        }
    }

    const handleSendToBack = () => {
        let apiUrl = `${WEBBACK_V2_API}/reports/create`

        if (frequency.value === "now") {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: "lostBuyBoxDetails",
            conditions: normalizedConditionsFilters(),
            filters: {
                country: marketplacesLBBSubmittedFilters.value.country,
                retailer: marketplacesLBBSubmittedFilters.value.retailer,
                category: marketplacesLBBSubmittedFilters.value.category,
                brand: marketplacesLBBSubmittedFilters.value.brand,
                skuGroup: marketplacesLBBSubmittedFilters.value.skuGroup,
                sku: marketplacesLBBSubmittedFilters.value.sku,
                lostBuyBoxReason: marketplacesLBBSubmittedFilters.value.lostBuyBoxReason,
                id_customer: userCustomer
            },
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: "Error: Please try again later.",
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport,
        frequency,
        emailsReport,
        includeOnlyNewProducts
    }
}
